import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'letter-i', 'IconLetterI', [["path",{"d":"M12 4l0 16","key":"svg-0"}]]);